import { useCallback } from 'react';
import { Entity } from 'app/agriculture/queries/entities/types/Entity';
import { useGenericEntities } from 'app/agriculture/queries/entities/useGenericEntities';

/**
 * Returns a method to get the entity for a given id
 */
export function useGenericEntityFromId() {
    const entities = useGenericEntities();

    return useCallback(
        (id: string | number | null): Entity | undefined => {
            if (id == null) return;

            // check entities
            const entity = entities.get(id);

            // couldn't find the thing
            if (!entity) return;

            return entity;
        },
        [entities],
    );
}
